import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { environment } from './../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AssetidCopyModule } from './common/components/assetid-copy/assetid-copy.module';
import { AttractLoopPopupModule } from './common/components/attract-loop-popup/attract-loop-popup.module';
import { ConfirmDialogModule } from './common/components/confirm-dialog/confirm-dailog.module';
import { ContentLivePreviewModule } from './common/components/content-live-preview/content-live-preview.module';
import { DateTimeZoneModule } from './common/components/date-time-zone/date-time-zone.component/date-time-zone.module';
import { DateTimePickerModule } from './common/components/datetimepicker/datetimepicker-popover/datetimepicker.module';
import { DeleteModule } from './common/components/delete/delete.module';
import { SelectLangComponent } from './common/components/select-lang/select-lang.component';
import { SendToRetailerModule } from './common/components/send-to-retailer/send-to-retailer.module';
import { ShowonDeviceModule } from './common/components/showon-device/showon-device.component/showon-device.module';
import { ErrorInterceptor, TokenInterceptor } from './core/routing/interceptors';
import { CacheControlInterceptor } from './core/routing/interceptors/cache-control.interceptor';
import { SpinnerInterceptor } from './core/routing/interceptors/spinner.interceptor';
import { AuthService } from './core/routing/services/auth/auth.service';
import { CognitoUtil } from './core/routing/services/cognito/cognito.service';
import { DetailService } from './core/routing/services/details/detail.service';
import { UserParametersService } from './core/routing/services/userParamaters/user-parameters.service';
import { HttpMethodsService } from './core/routing/services/_helpers/http-methods.service';
import { AppGlobal } from './core/state/app-global';
import { AccountComponent } from './modules/account/account.component';
import { AccountModule } from './modules/account/account.module';
import { AssetLibraryModule } from './modules/asset-library/asset-library.module';
import { CreateProfileModule } from './modules/create-profile/create-profile.module';
import { FooterComponent } from './modules/footer/footer.component';
import { HeaderComponent } from './modules/header/header.component';
import { HomeComponent } from './modules/home/home.component';
import { DeleteComponent } from './modules/profile/delete/delete.component';
import { DuplicateComponent } from './modules/profile/duplicate/duplicate.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { UsersModule } from './modules/users/users.module';
import { DevicesModule } from './modules/devices/devices.module';
import { SendToSegmentAccountModule } from './common/components/send-to-segment-account/send-to-segment-account.module';
import { IposHelpModule } from './modules/ipos-help/ipos-help.module';
import { ApplyChangesToDeviceModule } from './common/components/apply-changes-to-devices/apply-changes-to-device.module';
import { ChartModule } from 'angular-highcharts';
import { StandardDownloadComponent } from './modules/profile/standard-download/standard-download.component';
import { PipeUtilModule } from './modules/pipes/pipe-util/pipe-util.module';
import { GoogleAnalyticsService } from '../app/modules/google-analytics/google-analytics.service';
import { OemPortalComponent } from './modules/oem-portal/oem-portal.component';
import { ModelSkuInfoComponent } from './modules/oem-portal/model-sku-info/model-sku-info.component';
import { NewModelSkuComponent } from './modules/oem-portal/new-model-sku/new-model-sku.component';
import { UploadThumbnailComponent } from './modules/oem-portal/new-model-sku/upload-thumbnail/upload-thumbnail.component';
import { UploadImageComponent } from './modules/oem-portal/new-model-sku/upload-image/upload-image.component';
import { UploadVideoComponent } from './modules/oem-portal/new-model-sku/upload-video/upload-video.component';
import { UploadStorelogoComponent } from './modules/oem-portal/new-model-sku/upload-storelogo/upload-storelogo.component';
import { NewSkuInfoComponent } from './modules/oem-portal/new-model-sku/new-sku-info/new-sku-info.component';
import { PartnerContentModule } from './modules/partner-content/partner-content.module';
import { OemPortalModule } from './modules/oem-portal/oem-portal.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CreateAttractorLoopOemComponent } from './modules/oem-portal/create-attractor-loop-oem/create-attractor-loop-oem.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AttractorLoopOemComponent } from './modules/oem-portal/attractor-loop/attractor-loop.component';
import { SkuIdsModule } from './modules/sku-ids/sku-ids.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SortModule } from '../app/modules/sort/sort.module';
import { ProfileTabsComponent } from './modules/profile/profile-tabs/profile-tabs.component';
import {CdTimerModule} from 'angular-cd-timer';
import { TwoFAComponent } from './modules/account/forgot-pwd/two-fa/two-fa.component';
@NgModule({
  declarations: [
    AppComponent,
    SelectLangComponent,
    HeaderComponent,
    FooterComponent,
    AccountComponent,
    HomeComponent,
    ProfileComponent,
    DeleteComponent,
    DuplicateComponent,
    StandardDownloadComponent,
    OemPortalComponent,
    ModelSkuInfoComponent,
    NewModelSkuComponent,
    UploadThumbnailComponent,
    UploadImageComponent,
    UploadVideoComponent,
    UploadStorelogoComponent,
    NewSkuInfoComponent,
    CreateAttractorLoopOemComponent,
    AttractorLoopOemComponent,
    ProfileTabsComponent,
    TwoFAComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    AccountModule,
    FontAwesomeModule,
    AssetLibraryModule,
    DateTimePickerModule,
    DeleteModule,
    CreateProfileModule,
    UsersModule,
    AssetidCopyModule,
    ConfirmDialogModule,
    UsersModule,
    ContentLivePreviewModule,
    DateTimeZoneModule,
    ShowonDeviceModule,
    AttractLoopPopupModule,
    SendToRetailerModule,
    DevicesModule,
    SendToSegmentAccountModule,
    IposHelpModule,
    ApplyChangesToDeviceModule,
    ChartModule,
    PipeUtilModule,
    PartnerContentModule,
    OemPortalModule,
    CKEditorModule,
    NgSelectModule,
    SkuIdsModule,
    DragDropModule,
    SortModule,
    CdTimerModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheControlInterceptor, multi: true },
    AppGlobal,
    HttpMethodsService,
    CognitoUtil,
    DetailService,
    UserParametersService,
    AuthService,
    GoogleAnalyticsService,
    { provide: 'googleTagManagerId', useValue: environment.gtmContainerId }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
